import React from 'react';
import Button from '../components/ui/Button';
import Accordion from '../components/ui/Accordion';
export default function FAQ() {
  const faqItems = [{
    title: 'How do the reminders work?',
    content: <>
          <p className="mb-3" data-id="element-247">
            Artisanfix sends automated reminders at the times you choose. You
            can receive reminders via SMS text message or phone call, depending
            on your preference.
          </p>
          <p className="mb-3" data-id="element-248">
            Simply set up your medication schedule or appointment dates in the
            dashboard, and we will send a reminder at the specified time. You
            can customise reminder times to suit your routine.
          </p>
          <p data-id="element-249">
            Reminders are clear and easy to understand, with straightforward
            instructions about what medication to take or which appointment is
            coming up.
          </p>
        </>
  }, {
    title: 'Can my family see the updates?',
    content: <>
          <p className="mb-3" data-id="element-250">
            Yes. Family members can access a shared dashboard where they can see
            when reminders have been sent and acknowledged.
          </p>
          <p className="mb-3" data-id="element-251">
            The number of family members who can access the dashboard depends on
            your chosen plan:
          </p>
          <ul className="list-disc pl-6 mb-3 space-y-1" data-id="element-252">
            <li data-id="element-253">Silver: 1 family member</li>
            <li data-id="element-254">Gold: Up to 3 family members</li>
            <li data-id="element-255">Platinum: Unlimited family members</li>
          </ul>
          <p data-id="element-256">
            This feature gives families peace of mind and helps everyone stay
            informed about medication adherence and upcoming appointments.
          </p>
        </>
  }, {
    title: 'Do I need a smartphone?',
    content: <>
          <p className="mb-3" data-id="element-257">
            No, you do not need a smartphone to receive reminders. Artisanfix
            works with any mobile phone that can receive SMS text messages or
            phone calls.
          </p>
          <p className="mb-3" data-id="element-258">
            However, to set up and manage reminders, you or a family member will
            need access to a computer, tablet, or smartphone with an internet
            connection to use the dashboard.
          </p>
          <p data-id="element-259">
            Once reminders are set up, the person receiving them only needs a
            basic mobile phone.
          </p>
        </>
  }, {
    title: 'How secure is my data?',
    content: <>
          <p className="mb-3" data-id="element-260">
            Your data is stored securely in the cloud using industry-leading
            encryption. We are fully compliant with UK GDPR regulations.
          </p>
          <p className="mb-3" data-id="element-261">
            We take data security very seriously and implement multiple layers
            of protection:
          </p>
          <ul className="list-disc pl-6 mb-3 space-y-1" data-id="element-262">
            <li data-id="element-263">All data is encrypted in transit and at rest</li>
            <li data-id="element-264">Regular security audits and updates</li>
            <li data-id="element-265">Strict access controls</li>
            <li data-id="element-266">No data is sold or shared with third parties</li>
          </ul>
          <p data-id="element-267">
            You can read more about our security practices in our Privacy &
            Cookie Policy.
          </p>
        </>
  }, {
    title: 'How do I cancel?',
    content: <>
          <p className="mb-3" data-id="element-268">
            You can cancel your subscription at any time by contacting our
            support team at bhagatjenith3@gmail.com or through your account
            dashboard.
          </p>
          <p className="mb-3" data-id="element-269">Refund policy:</p>
          <ul className="list-disc pl-6 mb-3 space-y-1" data-id="element-270">
            <li data-id="element-271">Within 14 days of purchase: Full refund, no questions asked</li>
            <li data-id="element-272">
              After 14 days: Refunds are at our discretion based on individual
              circumstances
            </li>
          </ul>
          <p data-id="element-273">
            There are no cancellation fees. If you cancel, your service will
            remain active until the end of your current billing period.
          </p>
        </>
  }, {
    title: 'Are there hidden fees?',
    content: <>
          <p className="mb-3" data-id="element-274">
            No, there are no hidden fees. The price you see is the price you
            pay.
          </p>
          <p className="mb-3" data-id="element-275">Your subscription includes:</p>
          <ul className="list-disc pl-6 mb-3 space-y-1" data-id="element-276">
            <li data-id="element-277">All reminders (SMS and phone calls)</li>
            <li data-id="element-278">Access to the family dashboard</li>
            <li data-id="element-279">Customer support</li>
            <li data-id="element-280">All features included in your chosen plan</li>
          </ul>
          <p data-id="element-281">
            All plans are billed annually. Secure payments are handled by
            Stripe, a trusted payment processor.
          </p>
        </>
  }];
  return <div className="w-full" data-id="element-282">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-white to-light-grey py-16" data-id="element-283">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-284">
          <h1 className="text-4xl md:text-5xl font-bold text-navy font-heading mb-6" data-id="element-285">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-dark" data-id="element-286">
            Find answers to common questions about Artisanfix.
          </p>
        </div>
      </section>
      {/* FAQ Accordion */}
      <section className="py-16 bg-white" data-id="element-287">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-288">
          <Accordion items={faqItems} data-id="element-289" />
        </div>
      </section>
      {/* Still Have Questions */}
      <section className="py-16 bg-light-grey" data-id="element-290">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-291">
          <h2 className="text-3xl font-bold text-navy font-heading mb-4" data-id="element-292">
            Still Have Questions?
          </h2>
          <p className="text-lg text-dark mb-8" data-id="element-293">
            Our team is here to help. Get in touch and we will respond as soon
            as possible.
          </p>
          <Button size="lg" href="/contact" data-id="element-294">
            Contact Us
          </Button>
        </div>
      </section>
    </div>;
}